module.exports = __webpack_public_path__ + "static/media/SF-2-A.1c779d9b.mp3";